import  { useEffect, useState } from 'react';
import MenuHeader from './MenuHeader';
import MenuItem from './MenuItem';
import { useLocation, useParams } from 'react-router-dom';
import Loader from '../../../Components/Loader/Loader';
import axiosVendorInstance from '../../../axiosVendorInstance';

const ViewMenu = () => {
    const [restaurantData,setRestaurantData] = useState();
    const [isLoading, setIsLoading] = useState(false);
    const [searchQuery, setSearchQuery] = useState(''); 
    const {id} = useParams();
    const location = useLocation();
    const isNavigate = location.state;

    useEffect(() => {
        fetchMenuTypes();
    }, []);

    const fetchMenuTypes = async () => {
        try {
            setIsLoading(true);
            const response = await axiosVendorInstance.get(`/vendors/vendor/${id}`, {skipAuth: true});
            setIsLoading(false);
            const apiResponse = response?.data;
            setRestaurantData(apiResponse);
        } catch (error) {
            setIsLoading(false);
            console.error('Error fetching menu types:', error);
        }
    };

    return (
        <>
            {isLoading && <Loader/>}
            <MenuHeader restaurantData={restaurantData} searchQuery={searchQuery} setSearchQuery={setSearchQuery} isNavigate={isNavigate}/>
            <MenuItem restaurantData={restaurantData} searchQuery={searchQuery} isNavigate={isNavigate} id={id}/>
        </>
    );
};

export default ViewMenu;
